// extracted by mini-css-extract-plugin
module.exports = {"container":"Tabs_container__lCysu","tab":"Tabs_tab__ThJNN","selected":"Tabs_selected__Cs58F","outline":"Tabs_outline__6pI16"};